import { getMethod } from 'core-lib/utils/apiV2';
import { apiConfig } from 'core-lib/config/config';
import { getHeaders } from '../utils/headers';

function serializer(data) {
  return data?.data?.map((obj) => ({
    name: obj?.name,
    id: obj?.id || null,
    slug: obj?.slug || null,
    cover: obj?.cover || null,
    isPopular: obj?.is_popular || null,
  }));
}

const fetchCityList = async () => {
  const url = `${apiConfig('chariot')}/v1/locale/list`;

  const { response, error }: any = await getMethod({
    endPoint: url,
    headers: getHeaders(),
  });
  if (response) {
    return { response: serializer(response) };
  } else return { error: 'Something went wrong' };
};
export default fetchCityList;
